import React from 'react';
import styled from 'styled-components';

const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  font-family: ${({ theme }) => theme.fontFamily};
  font-weight: 400;
  font-size:  ${({ lableFontSize }) => lableFontSize};
`;

const SwitchLabel = styled.label`
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  height: ${({ sliderHeight }) => sliderHeight};
  margin-right: 10px;
`;

const SwitchInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
`;

const Slider = styled.span`
  position: relative;
  width: ${({ sliderWidth }) => sliderWidth};
  height: ${({ sliderHeight }) => sliderHeight};
  background-color: ${({ checked, theme, switchLabels, disabled }) =>
    disabled
      ? theme.dark80
      : switchLabels
      ? theme.primary
      : checked
      ? theme.primary
      : theme.dark80};
  border-radius: 34px;
  transition: background-color 0.4s;
  display: flex;
  align-items: center;
`;

const StatusText = styled.span`
  color: ${({ theme, checked, switchLabels }) =>
    switchLabels ? theme.white : checked ? theme.white : theme.dark40};
  position: absolute;
  left: ${({ checked }) => (checked ? '18px' : 'auto')};
  right: ${({ checked, rightValue }) => (checked ? 'auto' : rightValue)};
`;

const SliderButton = styled.span`
  position: absolute;
  content: '';
  height: ${({ circleHeight }) => `${circleHeight}px`};
  width: ${({ switchLabels, btnWidth, circleWidth }) =>
    switchLabels ? `${btnWidth}px` : `${circleWidth}px`};
  padding: ${({ switchLabels }) => (switchLabels ? '2px 10px' : '0')};
  left: ${({ checked, switchLabels, btnWidth, circleWidth }) =>
    checked
      ? `calc(100% - ${
          switchLabels ? `${btnWidth + 4}px` : `${circleWidth + 4}px`
        })`
      : '4px'};
  bottom: 4px;
  background-color: ${({ theme, checked, switchLabels, disabled }) =>
    disabled
      ? theme.dark60
      : switchLabels
      ? theme.white
      : checked
      ? theme.white
      : theme.dark60};
  border-radius: ${({ switchLabels }) => (switchLabels ? '30px' : '50%')};
  transition: left 0.4s;
  text-align: center;
`;

const StyledSwitch = ({
  checked,
  enableText = 'Enable',
  disableText = 'Disable',
  width = '95px',
  height = '34px',
  circleWidth = 26,
  circleHeight = 26,
  btnWidth = 75,
  rightValue = '10px',
  switchLabels = false,
  disabled = false,
  lableFontSize='14px',
  onChange = () => {},
  values
}) => {
  const onCheck = (e) => {
    if (disabled) return;
    onChange(e.target.checked);
  };
  return (
    <SwitchContainer data-values={checked ?? false} lableFontSize={lableFontSize}>
      <SwitchLabel sliderHeight={height}>
        <SwitchInput
          disabled={disabled}
          type="checkbox"
          checked={checked ?? false}
          onChange={onCheck}
        />
        <Slider
          checked={checked}
          sliderWidth={width}
          sliderHeight={height}
          switchLabels={switchLabels}
          disabled={disabled}
        >
          {switchLabels ? (
            <StatusText
              checked={checked}
              switchLabels={switchLabels}
              rightValue={rightValue}
              as="div"
            >
              {checked ? disableText : enableText}
            </StatusText>
          ) : (
            <StatusText
              checked={checked}
              switchLabels={switchLabels}
              rightValue={rightValue}
              as="div"
            >
              {checked ? enableText : disableText}
            </StatusText>
          )}
          <SliderButton
            checked={checked}
            switchLabels={switchLabels}
            btnWidth={btnWidth}
            circleWidth={circleWidth}
            circleHeight={circleHeight}
            disabled={disabled}
          >
            {switchLabels && <div>{checked ? enableText : disableText}</div>}
          </SliderButton>
        </Slider>
      </SwitchLabel>
    </SwitchContainer>
  );
};

export default StyledSwitch;
